import React from 'react';
import { Box, Divider, Stack, Typography } from '@mui/material';
import { Field } from '~/components/common/Formik';
import themes from '~/themes';
import { useFormikContext } from 'formik';
import { IDriver } from '../../../types';
import RegularSchedule from './RegularSchedule';
import SpecialSchedule from './SpecialSchedule';

type Props = {};

export const ShiftSchedule: React.FC<Props> = () => {
  const { values } = useFormikContext<IDriver>();

  return (
    <Stack color={themes.color.violet500}>
      <Stack flexDirection='column' gap={0.8}>
        <Typography color={themes.color.black} fontWeight={600}>
          Enable Shift Schedule
        </Typography>
        <Stack flexDirection='row' alignItems='center'>
          <Field.SwitchButton noText name='delivery.enable_delivery' />
          <Typography>
            Specify and manage driver work hours and leave times.
          </Typography>
        </Stack>
        <Typography>
          If auto-assignment is enabled, Breadstack will use the driver’s shift
          schedule to optimize task distribution.
        </Typography>
      </Stack>
      {values.delivery.enable_delivery && (
        <>
          <Divider sx={{ my: 1.6 }} />
          <RegularSchedule />
          <Divider sx={{ my: 1.6 }} />
          <SpecialSchedule />
          <Box height={50} />
        </>
      )}
    </Stack>
  );
};
